export const EmptyString = '';
export const MinInt: number = 0x80000000;